"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTwilioConversation = void 0;
const react_1 = require("react");
const dayjs_1 = __importDefault(require("dayjs"));
const conversations_1 = require("@twilio/conversations");
exports.useTwilioConversation = (token, name, identity) => {
    const [conversation, setConversation] = react_1.useState();
    const [messages, setMessages] = react_1.useState([]);
    react_1.useEffect(() => {
        if (!token || conversation) {
            return;
        }
        Promise.resolve().then(async () => {
            const transformMessage = (message) => {
                return {
                    id: message.sid,
                    author: message.author,
                    direction: message.author === identity ? 'outgoing' : 'incoming',
                    text: message.body,
                    createTime: dayjs_1.default(message.dateCreated).toISOString(),
                };
            };
            // Connect to chat
            const client = await conversations_1.Client.create(token);
            const conv = await client.getConversationByUniqueName(name);
            setConversation(conv);
            const response = await conv.getMessages(1000);
            const existingMessages = response.items.map((msg) => transformMessage(msg));
            setMessages((msgs) => [...msgs, ...existingMessages]);
            conv.on('messageAdded', (msg) => setMessages((msgs) => [...msgs, transformMessage(msg)]));
        });
    }, [token, name, identity, conversation]);
    return {
        conversation,
        messages,
    };
};
